import { Siren } from 'lucide-react'
import { useAlertPhase } from '../../hooks/useAlertPhase'
import { PHASE_META } from '../../lib/alert-phase'
import { cn } from '../../lib/utils'
import { AlertTicker } from './AlertTicker'
import { RealtimeDot } from './RealtimeDot'
import { UserMenu } from './UserMenu'

const accentClass: Record<string, string> = {
  IDLE: 'bg-transparent',
  WATCH: 'bg-watch',
  ALERT: 'bg-warning',
  CRITICAL: 'bg-critical animate-pulse',
}

const chipClass: Record<string, string> = {
  IDLE: 'border-border text-muted-foreground',
  WATCH: 'border-watch/60 text-watch',
  ALERT: 'border-warning/60 text-warning',
  CRITICAL: 'border-critical bg-critical-soft text-critical',
}

/** 顶栏：顶部相位色条 + 品牌区相位徽标，ALERT 及以上全应用可见 */
export function TopBar() {
  const phase = useAlertPhase()

  return (
    <header className="fixed inset-x-0 top-0 z-40">
      <div
        className={cn('h-0.5 transition-colors', accentClass[phase])}
        aria-hidden="true"
      />
      <div className="flex h-14 items-center gap-4 border-b border-border bg-background/90 px-4 backdrop-blur-xl lg:px-6">
        <div className="flex items-center gap-2.5">
          <span
            className={cn(
              'grid size-8 place-items-center rounded-lg text-primary',
              phase === 'CRITICAL' ? 'bg-critical-soft text-critical' : 'bg-primary/15',
            )}
          >
            <Siren size={18} />
          </span>
          <div className="leading-tight">
            <div className="text-sm font-semibold tracking-[.22em] text-foreground">SEVEN</div>
            <div className="text-[9px] tracking-wider text-muted-foreground/70">天穹应急响应网络</div>
          </div>
          <span
            aria-label={`系统状态：${PHASE_META[phase].label}`}
            className={cn(
              'ml-1 rounded border px-1.5 py-px font-mono text-[10px] leading-4',
              chipClass[phase],
            )}
          >
            {PHASE_META[phase].label}
          </span>
        </div>
        <div className="ml-auto flex items-center gap-4">
          <RealtimeDot />
          <UserMenu />
        </div>
      </div>
      <div className="flex">
        <AlertTicker />
      </div>
    </header>
  )
}
